import { create } from "zustand";

type EditExistingOrderDialogStoreState = {
  isEditExistingOrderDialogVisible: boolean;
  hasShownEditExistingOrderDialog: boolean;
};

type EditExistingOrderDialogStoreActions = {
  showEditExistingOrderDialog: () => void;
  hideEditExistingOrderDialog: () => void;
  resetHasShownEditOrderExistingDialog: () => void;
};

export const useEditExistingOrderStore = create<
  EditExistingOrderDialogStoreState & EditExistingOrderDialogStoreActions
>((set) => ({
  isEditExistingOrderDialogVisible: false,
  hasShownEditExistingOrderDialog: false,

  showEditExistingOrderDialog: () =>
    set(() => ({
      isEditExistingOrderDialogVisible: true,
      hasShownEditExistingOrderDialog: true,
    })),
  hideEditExistingOrderDialog: () =>
    set(() => ({ isEditExistingOrderDialogVisible: false })),

  resetHasShownEditOrderExistingDialog: () =>
    set(() => ({
      hasShownEditExistingOrderDialog: false,
    })),
}));
